/**
 * Created by lixueying on 2017/1/16.
 */
import Vue from 'vue'

let bus = new Vue();


export default bus;
